/** Platform ops UI — distinct from landlord/wholesale tenant themes */
export const PLATFORM_CSS = `
  .plat-page { min-height: 100vh; font-family: 'DM Sans', system-ui, sans-serif; background: #0f172a; color: #e2e8f0; }
  .plat-shell { display: flex; min-height: 100vh; }
  .plat-sidebar {
    width: 240px; flex-shrink: 0; background: #020617; border-right: 1px solid #1e293b;
    padding: 20px 14px; display: flex; flex-direction: column; gap: 6px;
  }
  .plat-brand { padding: 8px 12px 20px; border-bottom: 1px solid #1e293b; margin-bottom: 8px; }
  .plat-brand h1 { margin: 0; font-size: 18px; font-weight: 800; color: #f8fafc; letter-spacing: -0.02em; }
  .plat-brand p { margin: 4px 0 0; font-size: 11px; color: #64748b; font-weight: 600; text-transform: uppercase; letter-spacing: 0.08em; }
  .plat-nav { display: flex; flex-direction: column; gap: 2px; flex: 1; overflow-y: auto; }
  .plat-nav-section {
    font-size: 10px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.1em;
    color: #475569; padding: 16px 12px 6px; margin-top: 2px;
  }
  .plat-nav-section:first-child { padding-top: 4px; }
  .plat-nav a {
    display: flex; align-items: center; justify-content: space-between; gap: 8px;
    padding: 10px 12px; border-radius: 10px; text-decoration: none; color: #94a3b8;
    font-size: 13px; font-weight: 700; transition: background 0.15s, color 0.15s;
  }
  .plat-nav a:hover { background: #1e293b; color: #f1f5f9; }
  .plat-nav a.active { background: linear-gradient(135deg, #4338ca, #6366f1); color: #fff; box-shadow: 0 4px 14px rgba(99,102,241,0.35); }
  .plat-badge { background: #ef4444; color: #fff; border-radius: 999px; padding: 1px 7px; font-size: 10px; font-weight: 800; }
  .plat-main { flex: 1; padding: 28px 32px; overflow: auto; background: linear-gradient(180deg, #0f172a 0%, #111827 100%); }
  .plat-header { display: flex; justify-content: space-between; align-items: flex-start; gap: 16px; margin-bottom: 24px; flex-wrap: wrap; }
  .plat-header h2 { margin: 0; font-size: 26px; font-weight: 800; color: #f8fafc; letter-spacing: -0.03em; }
  .plat-header p { margin: 6px 0 0; font-size: 13px; color: #64748b; }
  .plat-btn {
    border: none; border-radius: 10px; padding: 10px 16px; font-weight: 700; font-size: 13px;
    cursor: pointer; font-family: inherit; transition: opacity 0.15s;
  }
  .plat-btn:disabled { opacity: 0.5; cursor: not-allowed; }
  .plat-btn-primary { background: #6366f1; color: #fff; }
  .plat-btn-ghost { background: #1e293b; color: #e2e8f0; border: 1px solid #334155; }
  .plat-btn-danger { background: transparent; color: #f87171; border: 1px solid #7f1d1d; }
  .plat-btn-sm { padding: 5px 10px; font-size: 12px; border-radius: 8px; }
  .plat-kpi-row { display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 12px; margin-bottom: 22px; }
  .plat-kpi { background: #1e293b; border: 1px solid #334155; border-radius: 14px; padding: 16px; }
  .plat-kpi .kl { font-size: 10px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.08em; color: #64748b; margin-bottom: 6px; }
  .plat-kpi .kv { font-size: 28px; font-weight: 800; color: #f8fafc; font-family: 'DM Mono', monospace; line-height: 1; }
  .plat-kpi.warn { border-color: #b45309; background: linear-gradient(145deg, #1e293b, #292524); }
  .plat-kpi.warn .kv { color: #fbbf24; }
  .plat-panel { background: #1e293b; border: 1px solid #334155; border-radius: 14px; padding: 18px 20px; margin-bottom: 18px; }
  .plat-panel h3 { margin: 0 0 14px; font-size: 14px; font-weight: 800; color: #f1f5f9; }
  .plat-toolbar { display: flex; gap: 10px; flex-wrap: wrap; align-items: center; margin-bottom: 14px; }
  .plat-search {
    flex: 1; min-width: 200px; max-width: 360px; padding: 10px 14px; border-radius: 10px;
    border: 1px solid #334155; background: #0f172a; color: #f1f5f9; font-size: 14px; font-family: inherit;
  }
  .plat-pills { display: flex; gap: 6px; flex-wrap: wrap; }
  .plat-pill {
    padding: 6px 12px; border-radius: 999px; border: 1px solid #334155; background: #0f172a;
    color: #94a3b8; cursor: pointer; font-size: 12px; font-weight: 700; font-family: inherit; text-transform: capitalize;
  }
  .plat-pill.active { background: #4338ca; border-color: #6366f1; color: #fff; }
  .plat-table-wrap { overflow-x: auto; border-radius: 12px; border: 1px solid #334155; }
  .plat-table { width: 100%; border-collapse: collapse; font-size: 13px; }
  .plat-table th { text-align: left; padding: 12px 14px; background: #0f172a; color: #64748b; font-size: 11px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.06em; border-bottom: 1px solid #334155; }
  .plat-table td { padding: 12px 14px; border-bottom: 1px solid #1e293b; color: #e2e8f0; vertical-align: top; }
  .plat-table tr:last-child td { border-bottom: none; }
  .plat-table tr:hover td { background: rgba(99,102,241,0.06); }
  .plat-table tr.selected td { background: rgba(99,102,241,0.12); }
  .plat-muted { color: #64748b; font-size: 12px; }
  .plat-empty { text-align: center; padding: 40px; color: #64748b; }
  .plat-split { display: grid; grid-template-columns: 1fr 380px; gap: 18px; align-items: start; }
  .plat-ticket-card { border: 1px solid #334155; border-radius: 12px; padding: 12px 14px; margin-bottom: 10px; cursor: pointer; background: #0f172a; }
  .plat-ticket-card:hover { border-color: #6366f1; }
  .plat-ticket-card.active { border-color: #6366f1; background: rgba(99,102,241,0.1); }
  .plat-detail { background: #0f172a; border: 1px solid #334155; border-radius: 12px; padding: 16px; max-height: 70vh; overflow-y: auto; }
  .plat-msg { background: #1e293b; border-radius: 10px; padding: 10px 12px; margin-bottom: 8px; font-size: 13px; line-height: 1.5; white-space: pre-wrap; }
  .plat-msg.ops { border-left: 3px solid #6366f1; }
  .plat-textarea {
    width: 100%; min-height: 80px; padding: 10px 12px; border-radius: 10px; border: 1px solid #334155;
    background: #0f172a; color: #f1f5f9; font-family: inherit; font-size: 13px; resize: vertical; box-sizing: border-box;
  }
  .plat-drawer-backdrop {
    position: fixed; inset: 0; background: rgba(2, 6, 23, 0.65); z-index: 100;
  }
  .plat-drawer {
    position: fixed; top: 0; right: 0; width: min(420px, 100vw); height: 100vh;
    background: #1e293b; border-left: 1px solid #334155; z-index: 101;
    padding: 24px 22px; overflow-y: auto; box-shadow: -12px 0 40px rgba(0,0,0,0.35);
  }
  .plat-drawer h3 { margin: 0 0 6px; font-size: 20px; font-weight: 800; color: #f8fafc; }
  .plat-drawer-close {
    position: absolute; top: 16px; right: 16px; background: #0f172a; border: 1px solid #334155;
    color: #94a3b8; border-radius: 8px; width: 32px; height: 32px; cursor: pointer; font-size: 18px;
  }
  .plat-detail-row { display: flex; justify-content: space-between; gap: 12px; padding: 10px 0; border-bottom: 1px solid #334155; font-size: 13px; }
  .plat-detail-row .label { color: #64748b; font-weight: 700; font-size: 11px; text-transform: uppercase; letter-spacing: 0.06em; }
  .plat-kpi-link { text-decoration: none; color: inherit; display: block; cursor: pointer; transition: transform 0.12s, box-shadow 0.12s; }
  .plat-kpi-link:hover { transform: translateY(-2px); box-shadow: 0 8px 24px rgba(99,102,241,0.15); }
  .plat-select {
    padding: 8px 12px; border-radius: 8px; border: 1px solid #334155; background: #0f172a;
    color: #f1f5f9; font-size: 13px; font-family: inherit; width: 100%;
  }
    .plat-shell { flex-direction: column; }
    .plat-sidebar { width: 100%; flex-direction: row; flex-wrap: wrap; border-right: none; border-bottom: 1px solid #1e293b; }
    .plat-nav { flex-direction: row; flex-wrap: wrap; }
    .plat-split { grid-template-columns: 1fr; }
    .plat-main { padding: 18px 14px; }
  }
`;
